// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25118
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25118
import { eventTrackingUtils } from "@/utils/eventTrackingUtils";
export const PageId = Object.freeze({
  MyJD_Main: "MyJD_Main",
});

interface IPVTrackParamsRecord {
  /** 我京（个人中心） */
  MyJD_Main: undefined;
}

const sendPv = {
  /** PV-我京（个人中心） */
  MyJD_Main: () => {
    eventTrackingUtils.submitPV({ page_id: PageId.MyJD_Main });
  },
};

interface IExpoTrackParamsRecord {
  /** 邀请好友 */
  MyJD_Main_Invite_Expo: undefined;
  /** 个人主页入口曝光 */
  MyJD_Main_Name_Expo: undefined;
  /** 收货地址入口曝光 */
  MyJD_Main_Addr_Expo: undefined;
  /** 设置按钮曝光 */
  MyJD_Main_Settings_Expo: undefined;
  /** 我的订单入口曝光 */
  MyJD_Main_Orders_Expo: undefined;
  /** 我的优惠券入口曝光 */
  MyJD_Main_Coupons_Expo: undefined;
  /** 我的心愿单入口曝光 */
  MyJD_Main_WishList_Expo: undefined;
  /** 我的浏览历史入口曝光 */
  MyJD_Main_History_Expo: undefined;
  /** 我的订单状态按钮曝光 */
  MyJD_Main_Orders_StatusBtn_Expo: {
    /** icon名称  */
    icon_name: string;
  };
  /** 个人信息页按钮曝光 */
  MyJD_Information_Main_Btn_Expo: {
    /** 标题  */
    title: string;
  };
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** 邀请好友 */
  MyJD_Main_Invite_Expo: "MyJD_Main_Invite_Expo",
  /** 个人主页入口曝光 */
  MyJD_Main_Name_Expo: "MyJD_Main_Name_Expo",
  /** 收货地址入口曝光 */
  MyJD_Main_Addr_Expo: "MyJD_Main_Addr_Expo",
  /** 设置按钮曝光 */
  MyJD_Main_Settings_Expo: "MyJD_Main_Settings_Expo",
  /** 我的订单入口曝光 */
  MyJD_Main_Orders_Expo: "MyJD_Main_Orders_Expo",
  /** 我的优惠券入口曝光 */
  MyJD_Main_Coupons_Expo: "MyJD_Main_Coupons_Expo",
  /** 我的心愿单入口曝光 */
  MyJD_Main_WishList_Expo: "MyJD_Main_WishList_Expo",
  /** 我的浏览历史入口曝光 */
  MyJD_Main_History_Expo: "MyJD_Main_History_Expo",
  /** 我的订单状态按钮曝光 */
  MyJD_Main_Orders_StatusBtn_Expo: "MyJD_Main_Orders_StatusBtn_Expo",
  /** 个人信息页按钮曝光 */
  MyJD_Information_Main_Btn_Expo: "MyJD_Information_Main_Btn_Expo",
});

interface IClickTrackParamsRecord {
  /** 个人信息修改 */
  MyJD_Main_Name: undefined;
  /** 收货地址入口点击 */
  MyJD_Main_Addr: undefined;
  /** 设置按钮点击 */
  MyJD_Main_Settings: undefined;
  /** 我的订单入口点击 */
  MyJD_Main_Orders: undefined;
  /** 我的优惠券入口点击 */
  MyJD_Main_Coupons: undefined;
  /** 我的心愿单入口点击 */
  MyJD_Main_WishList: undefined;
  /** 我的浏览历史入口点击 */
  MyJD_Main_History: undefined;
  /** 我的订单状态按钮点击 */
  MyJD_Main_Orders_StatusBtn: {
    /** icon名称  */
    icon_name: string;
  };
  /** 邀请好友点击 */
  MyJD_Main_Invite: undefined;
  /** 个人信息页按钮点击 */
  MyJD_Information_Main_Btn: {
    /** 标题  */
    title: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-个人信息修改 */
  MyJD_Main_Name: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Name" });
  },
  /** 点击事件上报-收货地址入口点击 */
  MyJD_Main_Addr: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Addr" });
  },
  /** 点击事件上报-设置按钮点击 */
  MyJD_Main_Settings: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Settings" });
  },
  /** 点击事件上报-我的订单入口点击 */
  MyJD_Main_Orders: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Orders" });
  },
  /** 点击事件上报-我的优惠券入口点击 */
  MyJD_Main_Coupons: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Coupons" });
  },
  /** 点击事件上报-我的心愿单入口点击 */
  MyJD_Main_WishList: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_WishList" });
  },
  /** 点击事件上报-我的浏览历史入口点击 */
  MyJD_Main_History: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_History" });
  },
  /** 点击事件上报-我的订单状态按钮点击 */
  MyJD_Main_Orders_StatusBtn: (json_param: IClickTrackParamsRecord["MyJD_Main_Orders_StatusBtn"]) => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Orders_StatusBtn", json_param });
  },
  /** 点击事件上报-邀请好友点击 */
  MyJD_Main_Invite: () => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Main_Invite" });
  },
  /** 点击事件上报-个人信息页按钮点击 */
  MyJD_Information_Main_Btn: (json_param: IClickTrackParamsRecord["MyJD_Information_Main_Btn"]) => {
    eventTrackingUtils.submitCL({ event_id: "MyJD_Information_Main_Btn", json_param });
  },
};

export { EXPOSURE_RECORD, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
